import { useState, useEffect } from 'react'
import { storeInfoService, StoreInfo } from '../services/storeInfoService'

function Footer() {
  const [storeInfo, setStoreInfo] = useState<StoreInfo>(storeInfoService.getStoreInfo())

  useEffect(() => {
    const unsubscribe = storeInfoService.subscribe(() => {
      setStoreInfo(storeInfoService.getStoreInfo())
    })
    return unsubscribe
  }, [])

  const workingHours = storeInfoService.getWorkingDaysHours()

  return (
    <footer className="bg-dark bg-opacity-25 text-white py-5">
      <div className="container">
        <div className="row g-4">
          <div className="col-md-4">
            <h3 className="h5 fw-bold mb-3">{storeInfo.businessName}</h3>
            <p className="text-light">
              {storeInfo.description}
            </p>
          </div>
          
          <div className="col-md-4">
            <h4 className="h6 fw-semibold mb-3">Quick Links</h4>
            <ul className="list-unstyled">
              <li className="mb-2"><a href="/classes" className="text-light text-decoration-none">Art Classes</a></li>
              <li className="mb-2"><a href="/about" className="text-light text-decoration-none">About Us</a></li>
              <li className="mb-2"><a href="/contact" className="text-light text-decoration-none">Contact</a></li>
              <li className="mb-2"><a href="/sitemap" className="text-light text-decoration-none">Site Map</a></li>
            </ul>
          </div>
          
          <div className="col-md-4">
            <h4 className="h6 fw-semibold mb-3">Visit Us</h4>
            <div className="text-light">
              <p className="mb-2">📍 {storeInfo.address.street}<br />{storeInfo.address.city}, {storeInfo.address.state} {storeInfo.address.zipCode}</p>
              <p className="mb-2">📞 {storeInfo.contact.phone}</p>
              <p className="mb-2">✉️ {storeInfo.contact.email}</p>
              <div className="mb-2">
                <span>🕒 </span>
                {workingHours.map((period, index) => (
                  <span key={index}>
                    {period.days}: {period.hours}
                    {index < workingHours.length - 1 && <br />}
                  </span>
                ))}
              </div>
              {storeInfo.social.facebook && (
                <a 
                  href={storeInfo.social.facebook} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-light text-decoration-none"
                >
                  📘 Follow us on Facebook
                </a>
              )}
            </div>
          </div>
        </div>
        
        <hr className="border-secondary my-4" />
        <div className="text-center text-muted">
          <p className="mb-1">&copy; {new Date().getFullYear()} {storeInfo.businessName}. All rights reserved.</p>
          <p className="small mb-0">Proudly serving the {storeInfo.address.city} art community since our founding.</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer